import moment from "moment";

const MOBILE_SCREEN_WIDTH = 768;

export function getResponsiveMoment() {
  moment.updateLocale('full', {
    relativeTime: {
      future: 'in %s',
      past: '%s ago',
      s: 'a few seconds',
      ss: '%d seconds',
      m: 'a minute',
      mm: '%d minutes',
      h: 'an hour',
      hh: '%d hours',
      d: 'a day',
      dd: '%d days',
      M: 'a month',
      MM: '%d months',
      y: 'a year',
      yy: '%d years',
    }
  });

  moment.updateLocale('short', {
    relativeTime: {
      future: 'in %s',
      past: '%s ago',
      s: 'S',
      ss: '%ds',
      m: '1m',
      mm: '%dm',
      h: '1h',
      hh: '%dh',
      d: '1d',
      dd: '%dd',
      M: '1mo',
      MM: '%dmo',
      y: '1y',
      yy: '%dy',
    }
  });

  const isMobile = window.innerWidth <= MOBILE_SCREEN_WIDTH;
  moment.locale(isMobile ? 'short' : 'full');

  return moment;
}

export default {
  moment,
  getResponsiveMoment
};